'use client'
import { RebuildNotice } from '@/components/RebuildNotice'

export type BasicEntity = { id: string; name: string; description?: string }

export default function GenericList({ entityLabel }: {
  entityLabel: string
  initialItems: BasicEntity[]
  nameLabel?: string
  withDescription?: boolean
}) {
  return <RebuildNotice title={entityLabel} />
}
